import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Conteiner = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;

  width: 50px;

  background-color: ${(props) => props.theme.PRIMARY};

  transition: 0.5s ease;
  overflow-x: hidden;
  white-space: nowrap;

  &:hover {
    width: 150px;
  }
`;

export const Nome = styled.div`
  align-self: flex-end;

  width: 0;

  z-index: 1;
  visibility: hidden;
  opacity: 0;
  transition:
    visibility 0s,
    opacity 0.3s ease-in;

  ${Conteiner}:hover && {
    padding: 0 10px;

    visibility: visible;
    opacity: 1;
  }
`;

export const IconeLink = styled(Link)`
  display: flex;
  justify-content: center;

  width: 100%;
  padding: 10px 5px;

  color: ${(props) => props.theme.LIGHT};

  z-index: 2;
  text-decoration: none;

  &:hover {
    background-color: ${(props) => props.theme.PRIMARY_DARKER};
  }

  ${Conteiner}:hover && {
    justify-content: flex-start;

    padding-left: 20px;
  }
`;

export const IconDefault = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 5px 0;

  color: ${(props) => props.theme[props.color]};
  background-color: ${(props) => props.theme.LIGHT};

  z-index: 2;
`;
